(function(){
  function initHero(root){
    if(!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const desktop = root.querySelector('[data-video-desktop]');
    const mobile = root.querySelector('[data-video-mobile]');
    const autoplay = root.dataset.autoplay === 'true';
    const loop = root.dataset.loop === 'true';

    function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }
    function activeVideo(){ return isMobile() ? (mobile || desktop) : (desktop || mobile); }

    function syncPlayback(){
      const active = activeVideo();
      [desktop,mobile].forEach(v=>{
        if(!v) return;
        if(v !== active){
          try { v.pause(); } catch(e){}
        }
      });
      if(!active || !autoplay) return;
      active.muted = true;
      active.playsInline = true;
      const p = active.play();
      if(p && typeof p.catch === 'function') p.catch(()=>{});
    }

    if(desktop && mobile){
      window.addEventListener('resize', function(){
        clearTimeout(root._vehResizeTimer);
        root._vehResizeTimer = setTimeout(syncPlayback, 140);
      }, {passive:true});
    }

    document.addEventListener('shopify:section:load', function(event){
      if(event.detail && event.detail.sectionId === root.dataset.sectionId) initHero(root);
    });

    syncPlayback();
  }

  function boot(){
    document.querySelectorAll('.veh[data-section-id]').forEach(initHero);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function(event){
    const root = document.getElementById('video-editorial-hero-' + (event.detail && event.detail.sectionId));
    if(root) initHero(root);
  });
})();
